import script from "./MultiSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./MultiSelect.vue?vue&type=script&setup=true&lang=js"

import "./MultiSelect.vue?vue&type=style&index=0&id=2ab66e08&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ab66e08"]])

export default __exports__